<script>
import { defineAsyncComponent } from 'vue'

import Config from '@/config'

export default {
  name: 'SvgIcon',
  props: {
    name: Proptypes.string(),
    color: Proptypes.string('currentColor'),
    width: Proptypes.string(''),
    height: Proptypes.string(''),
    size: Proptypes.string('24px'),
  },
  computed: {
    icon() {
      return defineAsyncComponent(() => import(`./source/${this.name}.svg`))
    },
    sizeObj() {
      const width = this.width || this.size
      const height = this.height || this.size

      return {
        width,
        height,
      }
    },
    styleWrap() {
      const styleObj = {
        '--size-svg': this.size,
        '--width-svg': this.sizeObj.width,
        '--height-svg': this.sizeObj.height,
      }

      return Object.entries(styleObj)
        .filter(([, value]) => !!value)
        .map(([key, value]) => `${key}: ${value};`)
        .join(' ')
    },
    style() {
      const styleObj = {
        color: this.color,
      }

      return Object.entries(styleObj)
        .filter(([, value]) => !!value)
        .map(([key, value]) => `${key}: ${value};`)
        .join(' ')
    },
    devMeta() {
      return Config.isDev
        ? {
            'data-name': this.name,
          }
        : {}
    },
    attributes() {
      return {
        ...this.$attrs,
        ...this.$data,
      }
    },
  },
}
</script>

<template>
  <span class="tamara-svg-icon" :style="styleWrap">
    <component
      :is="icon"
      class="tamara-svg-icon__svg"
      :style="style"
      v-bind="devMeta"
    />
  </span>
</template>

<style lang="scss">
.tamara-svg-icon {
  font-size: var(--size-svg);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  letter-spacing: normal;
  user-select: none;
  line-height: 1;
  text-indent: 0;
  font-feature-settings: 'liga';
  vertical-align: middle;
  position: relative;

  &__svg {
    width: var(--width-svg);
    height: var(--height-svg);
  }
}
</style>
